<template>
	<el-dialog
		:title="$t('modifyPass.name')"
		:visible.sync="isActive"
		:destroy-on-close="true"
		:before-close="closeDialog"
		width="600px"
		>
		<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="80px" class="password-ruleForm">
			<el-form-item :label="$t('modifyPass.form.oldPass')" prop="oldPass">
				<template slot="label">
					{{$t('modifyPass.form.oldPass')}}<span class="required">*</span>
				</template>
				<el-input type="password" v-model="ruleForm.oldPass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('modifyPass.form.newPass')" prop="pass">
				<template slot="label">
					{{$t('modifyPass.form.newPass')}}<span class="required">*</span>
				</template>
				<el-input type="password" v-model="ruleForm.pass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item :label="$t('modifyPass.form.checkPass')" prop="checkPass">
				<template slot="label">
					{{$t('modifyPass.form.checkPass')}}<span class="required">*</span>
				</template>
				<el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" @click="closeDialog">{{$t('btns.cancel')}}</el-button>
				<el-button size="small" type="primary" @click="submitForm('ruleForm')">{{$t('btns.confirm')}}</el-button>
			</el-form-item>
		</el-form>  
	</el-dialog>
</template>

<script>
import md5 from 'js-md5'
import {
  modifyPassword
} from '@/api/modifyPassword'
export default {
	name: "ModifyPassword",
	props: {
		isActive: {
			type: Boolean,
			default: false
		}
	},
	data(){
		var validateOldPass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('modifyPass.rules.oldPass')));
			} else {
				callback();
			}
		};
		var validatePass = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('modifyPass.rules.newPass')));
			} else {
				if (this.ruleForm.checkPass !== '') {
					this.$refs.ruleForm.validateField('checkPass');
				}
				callback();
			}
		};
		var validatePass2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error(this.$t('modifyPass.rules.enterAgain')));
			} else if (value !== this.ruleForm.pass) {
				callback(new Error(this.$t('modifyPass.rules.inconformityPass')));
			} else {
				callback();
			}
		};
		return{
			isShow: this.isActive,
			ruleForm: {
				oldPass: '',
				pass: '',
				checkPass: ''
			},
			rules: {
				oldPass: [
					{ required: true, validator: validateOldPass, trigger: 'blur' }
				],
				pass: [
					{ required: true, validator: validatePass, trigger: 'blur' }
				],
				checkPass: [
					{ required: true, validator: validatePass2, trigger: 'blur' }
				]
			}
		}
	},
	methods: {
		initForm(){
			this.ruleForm = {
				oldPass: '',
				pass: '',
				checkPass: ''
			}
		},
		closeDialog(){
			this.$emit('closeDialog')
		},
		submitForm(formName){
			this.$refs[formName].validate((valid) => {
				if (valid) {
					let data = {
						newPassword: md5(this.ruleForm.pass.trim()),
						oldPassword: md5(this.ruleForm.oldPass.trim())
					}
					modifyPassword(data).then((res) => {
						this.modalLoading = false
						if (res.code == 200) {
							this.closeDialog()
							this.$message.success(this.$t('modifyPass.message.success'))
							setTimeout(()=>{
								this.logout()
							}, 2500)
						} else {
							this.$message.error(res.msg || this.$t('generalData.warning.operationFail'))
						}
					}).catch((err) => {
						this.$message.error(err && err.msg)
					})
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		async logout() {
      await this.$store.dispatch('FedLogOut')
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
	}
}
</script>

<style lang="scss" scoped>
	.el-dialog__body .el-input{
		width: 100%;
		max-width: 100%;
	}
	.password-ruleForm .required {
    margin-left: 2px;
    color: #ff4949;
	}
</style>
<style lang="scss">
	.el-dialog .password-ruleForm .el-form-item{
		margin-bottom: 22px;
	}
	.el-dialog__body .password-ruleForm .el-form-item__label{
		font-weight: normal !important;
	}
	.password-ruleForm .el-form-item:last-child{
		text-align: right;
		margin-bottom: 0;
		.el-button + .el-button{
			margin-left: 15px;
		}
	}
</style>